// extracted by mini-css-extract-plugin
export default {"container-fluid":"AddtoCart_container-fluid__-oZnR"};